module.exports = __webpack_public_path__ + "static/banner-04877c610bac4f7bf5945d5f45d068fd.svg";